import React, { useEffect, useState } from "react";
import FooterOne from "../common/footer/FooterOne";
import HeaderOne from "../common/header/HeaderOne";
import BcrumbBannerOne from "../elements/breadcrumb/BcrumbBannerOne";
import ColorSwitcher from "../elements/switcher/ColorSwitcher";
import SEO from "../common/SEO";
import CtaLayoutOne from "../component/cta/CtaLayoutOne";
import SectionTitle from "../elements/section-title/SectionTitle";
import ServiceProp from "../component/service/ServiceProp";
import ServiceData from "../data/service/ServiceMain.json";
import { slugify } from "../utils";
import AboutThree from "../component/about/AboutThree";
import CounterUpTwo from "../component/counterup/CounterUpTwo";
import BcrumbBannerTwo from "../elements/breadcrumb/BcrumbBannerTwo";
import ClientSlider from "../component/client/ClientSlider";

const allData = ServiceData;

const bannerData = [
  {
    title: "Expert Maintenance For All Your Facility’s Essential Systems",
    paragraph:
      "Ensure your facility operates smoothly with our expert maintenance and repair services. From HVAC to electrical systems, we handle it all with precision",
    mainThumb: "/images/serviceucwf/main-service/main-service-banner1.webp",
  },
  {
    title: "Redefining Convenience with World-Class Concierge Services",
    paragraph: "Concierge Assistance – Anytime, Anywhere",
    mainThumb: "/images/serviceucwf/main-service/main-service-banner2.webp",
  },
  {
    title: "Your Shield Against Pests -Trusted & Certified Solutions",
    paragraph: " Safe, Sustainable, and Effective",
    mainThumb: "/images/serviceucwf/main-service/main-service-banner3.webp",
  },
  // Add more slides as needed
];

const ServiceOne = () => {
  const [isTabletOrBelow, setIsTabletOrBelow] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsTabletOrBelow(window.innerWidth <= 1024);
    };
    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const designData = allData.filter(
    (data) => slugify(data.cate ? data.cate : "") === "design"
  );
  const developmentData = allData.filter(
    (data) => slugify(data.cate ? data.cate : "") === "development"
  );
  const marketingData = allData.filter(
    (data) => slugify(data.cate ? data.cate : "") === "online-marketing"
  );
  const businessData = allData.filter(
    (data) => slugify(data.cate ? data.cate : "") === "business"
  );
  const technologyData = allData.filter(
    (data) => slugify(data.cate ? data.cate : "") === "technology"
  );
  const strategyData = allData.filter(
    (data) => slugify(data.cate ? data.cate : "") === "content-strategy"
  );

  return (
    <>
      <SEO title="Service One" />
      {/* <ColorSwitcher /> */}
      <main className="main-wrapper">
        <HeaderOne />
        {/* <BcrumbBannerOne 
                title="Best solutions for your business"
                paragraph ="Give your business a unique logo to stand out from crowd. We’ll create logo specifically for your company.
                "
                styleClass=""
                mainThumb="/images/banner/main-banner.png"
                // mainThumb="/images/banner/banner-thumb-4.png"
            /> */}
        <BcrumbBannerTwo
          // title="Best solutions for your business"
          // paragraph="Give your business a unique logo to stand out from crowd. We’ll create logo specifically for your company."
          // styleClass=""
          // mainThumb="/images/banner/banner-thumb-4.png"
          // mainThumb="/images/banner/industry-img.jpg"
          subtitle="Where Quality Meets Commitment"
          bannerData={bannerData}
          page="Services"
          titleCategory="What We Deliver "
        />
        <div className="service-scroll-navigation-area">
          {/* Service Nav */}
          {/* <CounterUpTwo /> */}
          <nav
            id="onepagenav"
            className="service-scroll-nav navbar onepagefixed"
            style={{ paddingTop: isTabletOrBelow ? "15px" : "5px" }}
          >
            <div className="container">
              <ul className="nav nav-pills">
                <li className="nav-item">
                  <a
                    style={{ fontWeight: "600" }}
                    className="nav-link"
                    href="#ifm-services"
                  >
                    IFM Services
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    style={{ fontWeight: "600" }}
                    className="nav-link"
                    href="#hard-services"
                  >
                    Hard Services
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    style={{ fontWeight: "600" }}
                    className="nav-link"
                    href="#soft-services"
                  >
                    Soft Services
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    style={{ fontWeight: "600" }}
                    className="nav-link"
                    href="#security-services"
                  >
                    Security Services
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    style={{ fontWeight: "600" }}
                    className="nav-link"
                    href="#specialized-services"
                  >
                    Specialized Services
                  </a>
                </li>
              </ul>
            </div>
          </nav>

          <div className="section section-padding" id="ifm-services">
            <div className="container">
              <SectionTitle
                subtitle=""
                title="IFM Services"
                description=""
                textAlignment="heading-left"
                textColor=""
              />
              <div className="row">
                <ServiceProp
                  colSize="col-lg-4 col-md-6"
                  serviceStyle="service-style-2"
                  serviceData={technologyData}
                />
              </div>
            </div>
          </div>

          <div
            className="section section-padding bg-color-light"
            id="hard-services"
          >
            <div className="container">
              <SectionTitle
                subtitle=""
                title="Hard Services"
                description=""
                textAlignment="heading-left"
                textColor=""
              />
              <div className="row">
                <ServiceProp
                  colSize="col-lg-4 col-md-6"
                  serviceStyle="service-style-2"
                  serviceData={designData}
                />
              </div>
            </div>
          </div>

          <div className="section section-padding " id="soft-services">
            <div className="container">
              <SectionTitle
                subtitle=""
                title="Soft Services"
                description=""
                textAlignment="heading-left"
                textColor=""
              />
              <div className="row">
                <ServiceProp
                  colSize="col-lg-4 col-md-6"
                  serviceStyle="service-style-2"
                  serviceData={developmentData}
                />
              </div>
            </div>
          </div>

          <div
            className="section section-padding bg-color-light"
            id="security-services"
          >
            <div className="container">
              <SectionTitle
                subtitle=""
                title="Security Services"
                description=""
                textAlignment="heading-left"
                textColor=""
              />
              <div className="row">
                <ServiceProp
                  colSize="col-lg-4 col-md-6"
                  serviceStyle="service-style-2"
                  serviceData={marketingData}
                />
              </div>
            </div>
          </div>

          <div className="section section-padding " id="specialized-services">
            <div className="container">
              <SectionTitle
                subtitle=""
                title="Specialized Services"
                description=""
                textAlignment="heading-left"
                textColor=""
              />
              <div className="row">
                <ServiceProp
                  colSize="col-lg-4 col-md-6"
                  serviceStyle="service-style-2"
                  serviceData={businessData}
                />
              </div>
            </div>
          </div>
        </div>
        <CounterUpTwo />
        <AboutThree />
        <div className="container " style={{ paddingTop: "100px" }}>
          <SectionTitle
            subtitle="Our Clients"
            title="Our valued partners"
            textAlignment="heading-left mb--40"
            textColor=""
          />
        </div>
        {/* // In your page/component: */}
        <ClientSlider
          itemShow={4}
          colSize="col-md-3"
          columnGap="row-35"
          parentClass="your-custom-class"
        />
        {/* <CtaLayoutOne /> */}
        <FooterOne parentClass="" />
      </main>
    </>
  );
};

export default ServiceOne;
